import React from 'react';

import Layout from '../components/Layout';
import Scroll from '../components/Scroll';

import config from '../../config';
import Footer from '../components/Footer';
import Header from '../components/Header';
import ScrollToTop from '../components/ScrollToTop';


import p16 from '../assets/images/sports3.gif';
import p17 from '../assets/images/sports4.gif';
import p18 from '../assets/images/sports1.gif';

const IndexPage = () => (
  <Layout>
    <Header />

    <div className="col-lg-6">
            <a className="portfolio-item" href="#">
              <span className="caption">
                <span className="caption-content">
                  <h2></h2>
                  <p className="mb-0">
                   <b>World of Sports  with just a click...</b>
                  </p>
                </span>
              </span>
              <img className="img-fluid" src={p16} alt="" />
            </a>


          </div>

   

    


    

    <section className="content-section bg-primary text-white">
      <div className="container text-center">
        <h2 className="mb-4"></h2>
        <a href="https://www.skysports.com/" className="btn btn-xl btn-light mr-4">
         Skysports
        </a>
        <a href="https://www.goal.com/en-gh" className="btn btn-xl btn-dark">
          Goal
        </a>
      </div>
    </section>




<section className="content-section bg-primary text-white">
      <div className="container text-center">
        <h2 className="mb-4"></h2>
        <a href="https://espn.com/" className="btn btn-xl btn-light mr-4">
         ESPN
        </a>
        <a href="https://sports.yahoo.com/" className="btn btn-xl btn-dark">
          Yahoo Sports
        </a>
      </div>
    </section>










 <section className="content-section bg-primary text-white">
      <div className="container text-center">
        <h2 className="mb-4"></h2>
        <a href="https://www.90min.com/" className="btn btn-xl btn-light mr-4">
       90 MIN
        </a>
       <a href="https://www.nfl.com/" className="btn btn-xl btn-dark">
       NFL
        </a>
      </div>
    </section>










 <section className="content-section bg-primary text-white">
      <div className="container text-center">
        <h2 className="mb-4"></h2>
        <a href="https://www.livescore.com/" className="btn btn-xl btn-light mr-4">
        Livescore
        </a>
       <a href="https://highlightsfootball.net/" className="btn btn-xl btn-dark">
        Football HighLights 
        </a>
      </div>
    </section>


     <section className="content-section bg-primary text-white">
      <div className="container text-center">
        <h2 className="mb-4"></h2>
        <a href="http://www.hesgoal.com/" className="btn btn-xl btn-light mr-4">
          Hesgoal
        </a>
        <a href="https://www.livesoccertv.com/" className="btn btn-xl btn-dark">
          Live Soccer
        </a>
      </div>
    </section>




 <section className="content-section" id="portfolio">
      <div className="container">
        <div className="content-section-heading text-center">
          <h3 className="text-secondary mb-0">Browse Smartly</h3>
          <img className="img-fluid" src={p17} alt="" />
          <h2 className="mb-5">World of Sports on the Internet ..<i className="fa fa-football-ball fa-spin"></i></h2>
        </div>
        
      </div>
    </section>









     <section className="content-section bg-primary text-white">
      <div className="container text-center">
        <h2 className="mb-4"></h2>
        <a href="https://www.premierleague.com/live-streaming" className="btn btn-xl btn-light mr-4">
         Premier League Streaming
        </a>
        <a href="https://talksport.com/football/" className="btn btn-xl btn-dark">
          Talksports
        </a>

      </div>
    </section>

 



     <section className="content-section bg-primary text-white">
      <div className="container text-center">
        <h2 className="mb-4"></h2>
        <a href="https://hoofoot.com/" className="btn btn-xl btn-light mr-4">
         Hoofoot
        </a>
        <a href="https://www.nba.com/" className="btn btn-xl btn-dark">
          NBA
        </a>
      </div>
    </section>




 <section className="content-section bg-primary text-white">
      <div className="container text-center">
        <h2 className="mb-4"></h2>
        <a href="https://www.mlb.com/" className="btn btn-xl btn-light mr-4">
        MBL
        </a>
        <a href="https://www.foxsports.com/" className="btn btn-xl btn-dark">
          Fox Sports
        </a>
      </div>
    </section>



     <section className="content-section bg-primary text-white">
      <div className="container text-center">
        <h2 className="mb-4"></h2>
        <a href="https://bleacherreport.com/" className="btn btn-xl btn-light mr-4">
       Bleacher Report
        </a>
        <a href="https://www.si.com/" className="btn btn-xl btn-dark">
         Sports Illustrated (si)
        </a>
      </div>
    </section>









<section className="content-section bg-primary text-white">
      <div className="container text-center">
        <h2 className="mb-4"></h2>
        <a href="https://www.cbssports.com/nba/" className="btn btn-xl btn-light mr-4">
         CBS Sports
        </a>
        <a href="https://www.wwe.com/videos/playlists/live-from-wrestlemania-31-on-wwe-network" className="btn btn-xl btn-dark">
         WWE
        </a>
      </div>
    </section>



 <section className="content-section" id="portfolio">
      <div className="container">
        <div className="content-section-heading text-center">
          <h3 className="text-secondary mb-0">Browse Smartly</h3>
          <img className="img-fluid" src={p18} alt="" />
          <h2 className="mb-5">For the Love of the Game..<i className="fa fa-football-ball fa-spin"></i></h2>
        </div>
        
      </div>
    </section>


 <section className="content-section bg-primary text-white">
      <div className="container text-center">
        <h2 className="mb-4"></h2>
        <a href="https://www.bet365.com/#/HO/" className="btn btn-xl btn-light mr-4">
       Bet365
        </a>
        <a href="https://www.skihood.com/" className="btn btn-xl btn-dark">
         Skihood
        </a>
      </div>
    </section>



 <section className="content-section bg-primary text-white">
      <div className="container text-center">
        <h2 className="mb-4"></h2>
        <a href="https://www.sbnation.com/" className="btn btn-xl btn-light mr-4">
     SBNATION
        </a>
        <a href="https://www.bodybuilding.com/" className="btn btn-xl btn-dark">
         Body Building
        </a>
      </div>
    </section>



 <section className="content-section bg-primary text-white">
      <div className="container text-center">
        <h2 className="mb-4"></h2>
        <a href="https://www.nbcsports.com/" className="btn btn-xl btn-light mr-4">
       NBCS
        </a>
        <a href="https://deadspin.com/" className="btn btn-xl btn-dark">
         Dead Spin
        </a>
      </div>
    </section>



 <section className="content-section bg-primary text-white">
      <div className="container text-center">
        <h2 className="mb-4"></h2>
        <a href="https://www.cricbuzz.com/" className="btn btn-xl btn-light mr-4">
      Cric Buzz
        </a>
        <a href="https://www.si.com/" className="btn btn-xl btn-dark">
         Sports Illustrated (si)
        </a>
      </div>
    </section>











    {/* <section id="contact" className="map">
      <iframe
        width="100%"
        height="100%"
        frameborder="0"
        scrolling="no"
        marginheight="0"
        marginwidth="0"
        src="https://maps.google.com/maps?f=q&amp;source=s_q&amp;hl=en&amp;geocode=&amp;q=Twitter,+Inc.,+Market+Street,+San+Francisco,+CA&amp;aq=0&amp;oq=twitter&amp;sll=28.659344,-81.187888&amp;sspn=0.128789,0.264187&amp;ie=UTF8&amp;hq=Twitter,+Inc.,+Market+Street,+San+Francisco,+CA&amp;t=m&amp;z=15&amp;iwloc=A&amp;output=embed"
      ></iframe>
      <br />
      <small>
        <a href="https://maps.google.com/maps?f=q&amp;source=embed&amp;hl=en&amp;geocode=&amp;q=Twitter,+Inc.,+Market+Street,+San+Francisco,+CA&amp;aq=0&amp;oq=twitter&amp;sll=28.659344,-81.187888&amp;sspn=0.128789,0.264187&amp;ie=UTF8&amp;hq=Twitter,+Inc.,+Market+Street,+San+Francisco,+CA&amp;t=m&amp;z=15&amp;iwloc=A"></a>
      </small>
    </section> */}

    <ScrollToTop />
    <Footer />
  </Layout>
);

export default IndexPage;
